import { appThemeKey } from '../../constants';
import * as types from '../../mutationTypes';

export default {
  [types.SET_APP_THEME](state, value) {
    state.appTheme = value;
    localStorage.setItem(appThemeKey, value); // Save theme to local storage
  }
};
